<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Pre-Quote to Contract Conversion</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">
                                    <!-- <button pButton pRiple icon="pi pi-search" title="Back to Search"
                                        class="p-button p-button-success p-mr-2" (click)="goBack($event)"></button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <!-- <p-tabView  [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Customer Details"> -->
                        <form [formGroup]="tempconversionform">
                            <table class="normal-table">
                                <tr>

                                    <td style="width:17%" class="text-right">
                                        Temp Customer <span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <div class="p-inputgroup">
                                            <input type="text" disabled formControlName="customername" pInputText>
                                        </div>

                                    </td>
                                    <td class="text-right">Temp Customer Site <span class="hlt-txt">*</span></td>
                                    <td><input type="text" formControlName="customersitename" disabled pInputText> </td>
                                    <td class="text-right">Contract<span class="hlt-txt">*</span></td>
                                    <td>
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <div class="browse-links">
                                                    <a href="javascript:void(0)" (click)="OpenConversionImage()">
                                                        <p-button label="Link" styleClass="p-button-link"
                                                            title="{{ConversionImage}}"></p-button>
                                                    </a>
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-right">CommunicationMail<span class="hlt-txt">*</span></td>
                                    <td>
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <div class="browse-links">
                                                    <a href="javascript:void(0)" (click)="OpenCommunicationMailImage()">
                                                        <p-button label="Link" styleClass="p-button-link"
                                                            title="{{CommunicationMailURL}}"></p-button>
                                                    </a>
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="text-right">Customer GST File<span class="hlt-txt">*</span></td>
                                    <td>
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <div class="browse-links">
                                                    <a href="javascript:void(0)" (click)="OpenGstFileImage()">
                                                        <p-button label="Link" styleClass="p-button-link"
                                                            title="{{CustomerGSTfileURL}}"></p-button>
                                                    </a>
                                                </div>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="text-right">Cut off Day for Signed Contract</td>
                                    <td><p-calendar [showIcon]="true" formControlName="cutoffdateforsignedcontract"
                                        inputId="icon"></p-calendar></td>
                                </tr>
                            </table>
                            <div class="sub-title">
                                <div class="row">
                                    <div class="col-md-5">
                                        <h5>Location & Operation</h5>
                                    </div>
                                    <div class="col-md-7"></div>
                                </div>
                            </div>
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Booking Cut-off Time 
                                    </td>
                                    <td>
                                        <p-calendar [timeOnly]="true" formControlName="bookingcutofftime" disabled="true"
                                            inputId="timeonly"></p-calendar>
                                    </td>
                                    <td class="text-right">Vehicle Departure Cut-off Time
                                    </td>
                                    <td>
                                        <p-calendar [timeOnly]="true" disabled="true"
                                            formControlName="vehicledeparturecutofftime" inputId="timeonly">
                                        </p-calendar>
                                    </td>
                                    <td class="text-right">Pickup Cut-off Time
                                    </td>
                                    <td>
                                        <p-calendar [timeOnly]="true" formControlName="pickupcutofftime" disabled="true"
                                            inputId="timeonly"></p-calendar>
                                    </td>

                                </tr>
                            </table>
                            
                        </form>
                        <form [formGroup]="_ConversionForm">
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Customer Discussion</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Where<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false"
                                    formControlName="mEETING_WHERE" placeholder="Select"
                                    [filter]="true" [options]="meeting"
                                    optionLabel="metasubdescription" optionValue="metasubcode"></p-dropdown>
                                    <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('mEETING_WHERE').touched) && _ConversionForm.get('mEETING_WHERE').errors?.ConversionRequired">
                                            Please select Where
                                        </span>
                                </td>
                                <td class="text-right">Whom<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    
                                    <p-multiSelect [options]="userrole"                                                    
                                                formControlName="wHOM"
                                                [(ngModel)]="_selectedServiceLocation"  (onChange)="GetServiceLocations($event)"
                                                placeholder="Select"
                                                optionValue="loggeduser" optionLabel="loggeduser">
                                            </p-multiSelect>
                                            <span class="text-danger"
                                                *ngIf="(_submitted) && _ConversionForm.get('wHOM').errors?.ConversionRequired">
                                                Please Select Whom
                                            </span>
                                </td>
                                <!-- <td class="text-right">Customer Name<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <input type="text" formControlName="cUSTOMERNAME" maxlength="150" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('cUSTOMERNAME').touched) && _ConversionForm.get('cUSTOMERNAME').errors?.ConversionRequired">
                                            Please select Meeting Start Time
                                        </span>
                                </td> -->
                                <dt></dt>
                                <dt></dt>

                            </tr>
                            <tr>
                                <td class="text-right">Meeting Start Time<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-calendar  formControlName="mEETING_START" [showTime]="true"
                                    [minDate]="minDate" [showIcon]="true" appendTo="body"
                                        ></p-calendar>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('mEETING_START').touched) && _ConversionForm.get('mEETING_START').errors?.ConversionRequired">
                                            Please select Meeting Start Time
                                        </span>
                                </td>
                                <td class="text-right">Meeting End Time <span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-calendar  formControlName="mEETING_END" [showTime]="true"
                                    [minDate]="minDate" [showIcon]="true" appendTo="body"
                                        ></p-calendar>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('mEETING_END').touched) && _ConversionForm.get('mEETING_END').errors?.ConversionRequired">
                                            Please select Meeting End Time
                                        </span>
                                </td>
                                <td class="text-right">Discussion Points
                                </td>
                                <td>
                                    <textarea inputId="textarea" rows="3" cols="30" formControlName="dISCUSSED_POINTS" 
                                    pInputTextarea></textarea>
                                </td>                                
                            </tr>
                        </table>
                        </form>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>CONTRACT</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <p-tabView [(activeIndex)]="selectedtabContract">
                            <p-tabPanel header="General" *ngIf="HideGeneralRate">
                                <form [formGroup]="_CustomerSiteContractGeneralForm">
                                    <table class="normal-table">
                                        <tr>
                                            <td class="text-right">Rate Per Quintal/KM <span
                                                    class="hlt-txt">*</span></td>
                                            <td>
                                                <input type="text" formControlName="rateperqtlperkm" disabled
                                                    (keypress)="keypress.kpDecimalInput($event)" pInputText>
                                                <span class="text-danger"
                                                    *ngIf="(_CustomerSiteContractGeneralFormsubmitted) && _CustomerSiteContractGeneralForm.get('rateperqtlperkm').errors?.ContractRequired">
                                                    Please Enter the Rate Per Quintal/KM
                                                </span>
                                            </td>
                                            <td class="text-right">ODA Calculation Mode <span
                                                    class="hlt-txt">*</span></td>
                                            <td>
                                                <div class="p-formgroup-inline">
                                                    <div class="p-field-radiobutton"
                                                        *ngFor="let PF of _ODACalculationMode">
                                                        <p-radioButton name="odacalculationmodecode"
                                                            formControlName="odacalculationmodecode"
                                                            label={{PF.metasubdescription}} disabled="true"
                                                            inputIt="PF.metasubcode" value={{PF.metasubcode}}>
                                                        </p-radioButton>
                                                    </div>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(_CustomerSiteContractGeneralFormsubmitted) && _CustomerSiteContractGeneralForm.get('odacalculationmodecode').errors?.ContractRequired">
                                                    Please Select the ODA Calculation Mode
                                                </span>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <!--td class="text-right">Special Rate <span class="hlt-txt">*</span></td>
                                                    <td><input type="text" formControlName="frombranchcode" pInputText></td-->
                                        </tr>
                                    </table>
                                </form>
                            </p-tabPanel>
                            <p-tabPanel header="Region Level" *ngIf="HideRegionLevel">
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcelRegionList()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_RegionList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','toregion','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="toregion">To Region<p-sortIcon
                                                        field="toregion"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon
                                                        field="article"></p-sortIcon>
                                                </th>
                                                
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon
                                                        field="ratetype"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_RegionListGrid let-i="rowIndex">
                                            <tr>
                                                
                                                <td>
                                                    {{_RegionListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.toregion}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.article}}
                                                </td>
                                                
                                                <td>
                                                    {{_RegionListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Article Based" *ngIf="HideArticleBased">
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcelArticle()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_ArticleBasedList" [rows]="100" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','tobranch','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="tobranch"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true"
                                        [(selection)]="_Articleselectedrows">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="tobranch">To Branch<p-sortIcon
                                                        field="tobranch"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon
                                                        field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate Per Quintal/KM<p-sortIcon field="rate">
                                                </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Distance<p-sortIcon field="rate">
                                                </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon
                                                        field="ratetype"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Discount<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Final Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <!-- (dblclick)="onRowSelect_ArticleBasedList(_RegionListGrid, i)" -->
                                        <ng-template pTemplate="body" let-_RegionListGrid let-i="rowIndex">
                                            <tr>
                                               
                                                <td>
                                                    {{_RegionListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.tobranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.article}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.quintalRateperKM}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.distance}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.discount }}                                                        
                                                </td>
                                                <!-- <td>
                                                    {{_RegionListGrid.discount}}
                                                </td> -->
                                                <td>
                                                    {{_RegionListGrid.finalrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Slab" *ngIf="HideSlab">
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcelSlab()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_SlabFormList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','tobranch','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="tobranch">To Branch<p-sortIcon
                                                        field="tobranch"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon
                                                        field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon
                                                        field="ratetype"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_RegionListGrid let-i="rowIndex">
                                            <tr >
                                                
                                                <td>
                                                    {{_RegionListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.tobranch}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.article}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_RegionListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>


                            </p-tabPanel>
                            <p-tabPanel header="2D Rate" *ngIf="Hide2DRate">
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="exportExcel2DList()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="_2DList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['frombranch','toregion','article','ratetype','rate','dcratetype','dcrate','ddratetype','ddrate','acratetype','acrate','inclusiveorexclusive','isneedreversebooking']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" [scrollable]="true">
                                        <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                                <col style="width:150px">
                                            </colgroup>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                
                                                <th pSortableColumn="frombranch">From Branch<p-sortIcon
                                                        field="frombranch">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="toregion">To KM<p-sortIcon
                                                        field="toregion">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="article">Article<p-sortIcon
                                                        field="article">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ratetype">Rate Type<p-sortIcon
                                                        field="ratetype"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="rate">Rate<p-sortIcon field="rate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcratetype">DC Rate Type<p-sortIcon
                                                        field="dcratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcrate">DC Rate<p-sortIcon field="dcrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dcinclusiveorexclusive">DC Charges
                                                    <p-sortIcon field="dcinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddratetype">DD Rate Type<p-sortIcon
                                                        field="ddratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddrate">DD Rate<p-sortIcon field="ddrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="ddinclusiveorexclusive">DD Charges
                                                    <p-sortIcon field="ddinclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acratetype">Article Charge Code<p-sortIcon
                                                        field="acratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="acrate">AC Rate<p-sortIcon field="acrate">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="inclusiveorexclusive">Add on Charges
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="isneedreversebooking">Reverse Booking
                                                    <p-sortIcon field="isneedreversebooking">
                                                    </p-sortIcon>
                                                </th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_2DListGrid let-i="rowIndex">
                                            <tr >
                                                
                                                <td>
                                                    {{_2DListGrid.frombranch}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.toKM}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.article}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.dcratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.dcrate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.dcinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ddratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ddrate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.ddinclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.acratetype}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.acrate}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_2DListGrid.isneedreversebooking}}
                                                </td>


                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Waybill Heads / Other Charges">
                                <div class="card">
                                    <p-toolbar styleClass="p-mb-4">
                                        <ng-template pTemplate="left">
                                            <span class="p-input-icon-left">
                                                <i class="las la-search"></i>
                                                <input pInputText type="text"
                                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                    placeholder="Search..." />
                                            </span>
                                        </ng-template>

                                        <ng-template pTemplate="right">
                                            <button type="button" pButton pRipple icon="las la-file-excel"
                                                title="Export to Excel" class="p-button-success p-mr-2"
                                                (click)="ExportExcelWaybill()" pTooltip="XLS"
                                                tooltipPosition="bottom"></button>
                                        </ng-template>
                                    </p-toolbar>
                                    <p-table #dt [value]="WayBillList" [rows]="10" [paginator]="true"
                                        [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['chargecodeName','chargeratetype','adrate','inclusiveorexclusive','printinothercharge']"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true">
                                        <!-- <ng-template pTemplate="colgroup" let-columns>
                                                        <colgroup>
                                                            <col style="width:75px">
                                                            <col style="width:150px">
                                                            <col style="width:150px">
                                                            <col style="width:150px">
                                                            <col style="width:150px">
                                                            <col style="width:150px">
                                                            <col style="width:150px">
                                                        </colgroup>
                                                    </ng-template>  -->
                                        <ng-template pTemplate="header">
                                            <tr>
                                                
                                                <!--th style="text-align: center;width: 100px;">S.No</th-->
                                                <th pSortableColumn="chargecodeName">Charges type<p-sortIcon
                                                        field="chargecodeName">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="chargeratetype">Charges Code<p-sortIcon
                                                        field="chargeratetype">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="chargeratetype">Charge Rate Type
                                                    <p-sortIcon field="chargeratetype"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="adrate">Value <p-sortIcon field="adrate">
                                                    </p-sortIcon>
                                                </th>

                                                <th pSortableColumn="inclusiveorexclusive">Inclusive / exclusive
                                                    <p-sortIcon field="inclusiveorexclusive">
                                                    </p-sortIcon>
                                                </th>
                                                <th pSortableColumn="printinothercharge">Print in Other Charges
                                                    <p-sortIcon field="printinothercharge">
                                                    </p-sortIcon>
                                                </th>

                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-_WayBillListGrid let-i="rowIndex">
                                            <tr (dblclick)="onRowSelectWayBill(_WayBillListGrid, i)">
                                                
                                                <!--td style="width: 100px;">
                                                                {{i+1}}
                                                            </td-->
                                                <td>
                                                    {{_WayBillListGrid.chargetype}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.chargeratetype}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.chargeratetype}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.rate}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.inclusiveorexclusive}}
                                                </td>
                                                <td>
                                                    {{_WayBillListGrid.printinothercharge}}
                                                </td>

                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>

                            </p-tabPanel>
                        </p-tabView>
                        <!-- <p-tabView [(activeIndex)]="selectedtab">
                            <p-tabPanel header="Pickup Address"> -->
                        <!-- <table class="normal-table">
                            <tr>
                                <td class="text-right">Credit Worthiness<span class="hlt-txt">*</span></td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links">
                                                <a href="javascript:void(0)" (click)="OpenCreditWorthiness()">
                                                    <p-button label="Image" styleClass="p-button-link"
                                                        title="{{creditworthinessurl}}">
                                                    </p-button>
                                                </a>
                                            </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                            pTooltip="Browse File" tooltipPosition="top" mode="basic" #document
                                            accept=".pdf" maxFileSize="1000000" [auto]="true" chooseLabel="pdf"
                                            (onSelect)="CreditDocumentSelect($event,document)">
                                        </p-fileUpload>

                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel" type="button"
                                            (click)="onDocumentClearCredit()" tooltipPosition="top">
                                            <i class="pi pi-times"></i>
                                        </button>
                                        <span class="text-danger" *ngIf="(_submittedimage)">
                                            * Max Allowable file size 3 MB
                                        </span>
                                    </div>
                                </td>
                                <td class="text-right">Credit Assessment Score sheet<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links">
                                                <a href="javascript:void(0)" (click)="OpenAssessmentImage()">
                                                    <p-button label="Image" styleClass="p-button-link"
                                                        title="{{creditassessmentsurl}}">
                                                    </p-button>
                                                </a>
                                            </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only"
                                            pTooltip="Browse File" tooltipPosition="top" mode="basic" #document1
                                            accept=".pdf" maxFileSize="1000000" [auto]="true" chooseLabel="pdf"
                                            (onSelect)="AssessmentDocumentSelect($event,document1)">
                                        </p-fileUpload>

                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel" type="button"
                                            (click)="onDocumentClearAssessment()" tooltipPosition="top">
                                            <i class="pi pi-times"></i>
                                        </button>
                                        <span class="text-danger" *ngIf="(_submittedimage)">
                                            * Max Allowable file size 3 MB
                                        </span>
                                    </div>
                                </td>

                                <td></td>
                                <td></td>
                            </tr>
                            
                        </table> -->
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Waybill Configuration</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td class="text-right">Waybill Type<span class="hlt-txt">*</span></td>
                                <td>
                                    <form [formGroup]="_ConversionForm">
                                        <p-dropdown [autoDisplayFirst]="false" formControlName="waybillnumbertypecode" required
                                            placeholder="Select" [filter]="true" [options]="_WaybillType" 
                                            optionValue="metasubcode" optionLabel="metasubdescription"></p-dropdown>
                                    </form>
                                    <span class="text-danger"
                                        *ngIf="(_submitted || _ConversionForm.get('waybillnumbertypecode').touched) && _ConversionForm.get('waybillnumbertypecode').errors?.ConversionRequired">
                                        Please Select Waybill Type
                                    </span>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>

                            <!-- <tr>
                                        <td colspan="6" class="text-center">
                                            <button pButton label="Add" class="p-button-success" ></button>
                                            <button pButton label="Clear" class="p-button-warning"></button>
                                        </td>
                                    </tr> -->
                        </table>

                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Commission Configuration</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <form [formGroup]="_Commissionform">
                            <table class="normal-table">
                                <tr>
                                    <td class="text-right">Commission Type<span class="hlt-txt">*</span></td>
                                    <td>
                                        <form [formGroup]="_ConversionForm">
                                            <p-dropdown [autoDisplayFirst]="false"
                                                formControlName="bookingcommissiontypecode" placeholder="Select"
                                                [filter]="true" [options]="_CommissionType" optionValue="metasubcode"
                                                optionLabel="metasubdescription"></p-dropdown>
                                        </form>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('bookingcommissiontypecode').touched) && _ConversionForm.get('bookingcommissiontypecode').errors?.ConversionRequired">
                                            Please Select Commission Type
                                        </span>
                                    </td>
                                    <td class="text-right">Above Card Rate %<span class="hlt-txt">*</span></td>
                                    <td>
                                        <form [formGroup]="_ConversionForm">
                                            <input type="text" formControlName="abovecardratecommissionpercentage"
                                                pInputText>
                                        </form>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('abovecardratecommissionpercentage').touched) && _ConversionForm.get('abovecardratecommissionpercentage').errors?.ConversionRequired">
                                            Please enter Above Card Rate %
                                        </span>
                                    </td>
                                    <td></td>
                                    <td></td>

                                </tr>
                                <tr>
                                    <td class="text-right">Below Card Rate From<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" formControlName="belowcardratefrom" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_submittedCommission || _Commissionform.get('belowcardratefrom').touched) && _Commissionform.get('belowcardratefrom').errors?.ConversionRequired">
                                            Please enter Below Card Rate From
                                        </span>
                                    </td>
                                    <td class="text-right">Below Card Rate To<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" disabled formControlName="belowcardrateto" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_submittedCommission || _Commissionform.get('belowcardrateto').touched) && _Commissionform.get('belowcardrateto').errors?.ConversionRequired">
                                            Please enter Below Card Rate To
                                        </span>
                                    </td>
                                    <td class="text-right">Commission % on Freight<span class="hlt-txt">*</span></td>
                                    <td>
                                        <input type="text" formControlName="commissionpercentage" pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_submittedCommission || _Commissionform.get('commissionpercentage').touched) && _Commissionform.get('commissionpercentage').errors?.ConversionRequired">
                                            Please enter Commission % on Freight
                                        </span>
                                    </td>


                                </tr>

                                <tr>
                                    <td colspan="6" class="text-center">
                                        <button pButton label="Add" (click)="AddCommission()"
                                            class="p-button-success"></button>
                                        <button pButton label="Clear" (click)="RemoveCommission()"
                                            class="p-button-warning"></button>
                                    </td>
                                </tr>
                            </table>
                        </form>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                        [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                        [rowHover]="true" dataKey="id"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [showCurrentPageReport]="true" > -->

                            <p-table #dt [value]="CommissionConfigList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['belowcardratefrom','belowcardrateto','commissionpercentage']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">

                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                            <colgroup>
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:150px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width: 100px">
                                                <col style="width:150px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                                <col style="width:250px">
                                            </colgroup>
                                        </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="text-align: center;width: 100px;">Action</th>
                                        <th pSortableColumn="agentNo">S. No <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="belowcardratefrom">Below Card Rate From<p-sortIcon
                                                field="belowcardratefrom">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="belowcardrateto">Below Card Rate To <p-sortIcon
                                                field="belowcardrateto">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="commissionpercentage">Commission % on Freight <p-sortIcon
                                                field="commissionpercentage">
                                            </p-sortIcon>
                                        </th>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList let-i="rowIndex">
                                    <tr>
                                        <td>
                                            <!-- <button pButton pRipple title="Add" icon="pi pi-plus"
                                                        class="p-button-success p-mr-2" 
                                                        ></button> -->
                                            <button pButton pRipple title="Remove"
                                                *ngIf="!_ManageCustomerList.isdisabledremove"
                                                (click)="RemoveCommisiongrid(_ManageCustomerList)" icon="pi pi-trash"
                                                class="p-button-danger p-mr-2"></button>
                                        </td>
                                        <td>
                                            {{i+1}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.belowcardratefrom}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.belowcardrateto}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.commissionpercentage}}
                                        </td>

                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <!-- </p-tabPanel>
                            <p-tabPanel header="Billing Address"> -->

                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Other Charges Commission</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <!-- <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" > -->

                            <p-table #dt [value]="OtherChargesList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['chargeCode','chargeName','commissionpercentage']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">

                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width: 100px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>

                                        <th style="text-align: center;width: 100px;">S.No </th>
                                        <th style="width: 150px;" pSortableColumn="chargeCode">Charge Code <p-sortIcon
                                                field="chargeCode">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="chargeName">Charge Name<p-sortIcon field="chargeName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="commissionpercentage">Commmission percentage<p-sortIcon
                                                field="commissionpercentage">
                                            </p-sortIcon>
                                        </th>


                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList let-i="rowIndex">
                                    <tr>


                                        <td style="text-align: center;">
                                            {{i+1}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.chargeCode}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.chargeName}}
                                        </td>
                                        <td pEditableColumn>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <input type="text"
                                                        [(ngModel)]="_ManageCustomerList.commissionpercentage"
                                                        pInputText>
                                                    <!-- (keypress)="keypress.kpNumber($event)"  <div *ngIf="_action == 'view'">{{_customerslabdetail.minimumvalue}}</div> (focusout)="checkDuplicate($event,'minimumvalue',i)" -->
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{_ManageCustomerList.commissionpercentage}}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>

                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Door Collection</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <form [formGroup]="_ConversionForm">
                            <table class="normal-table">
                                <tr>
                                    <td style="width:17%" class="text-right">
                                        Agent Vehicle Reimbursement %<span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" formControlName="agentvehiclereimbursementpercentage"
                                            pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('agentvehiclereimbursementpercentage').touched) && _ConversionForm.get('agentvehiclereimbursementpercentage').errors?.ConversionRequired">
                                            Please entere Agent Vehicle Reimbursement %
                                        </span>
                                    </td>
                                    <td style="width:17%" class="text-right">
                                        Attached Vehicle Reimbursement %<span class="hlt-txt">*</span>
                                    </td>
                                    <td>
                                        <input type="text" formControlName="attachedvehiclereimbursementpercentage"
                                            pInputText>
                                        <span class="text-danger"
                                            *ngIf="(_submitted || _ConversionForm.get('attachedvehiclereimbursementpercentage').touched) && _ConversionForm.get('attachedvehiclereimbursementpercentage').errors?.ConversionRequired">
                                            Please enter Vehicle Reimbursement %
                                        </span>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>

                            </table>
                        </form>
                        <!-- <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </ng-template>

                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel"
                                        title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>

                            <p-table #dt [value]="ManageCustomersList" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" >

                            <p-table #dt [value]="DoorCollectionList" [rows]="10" [paginator]="true"
                                [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['LEVELNAME','markuppercentage','vatpercentage','USD','CAD','ZAR','Currency4','Currency5']"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">

                              
                                <ng-template pTemplate="header">
                                    <tr>

                                        <th pSortableColumn="agentNo">Booking Commission Type <p-sortIcon field="agentNo">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Above Card Rate % <p-sortIcon field="agentName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">Agent Vehicle Reimbursement %<p-sortIcon field="fatherName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">Attached Vehicle Reimbursement %<p-sortIcon
                                                field="fatherName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">Effective From<p-sortIcon
                                                field="fatherName">
                                            </p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">Effective To<p-sortIcon
                                                field="fatherName">
                                            </p-sortIcon>
                                        </th>


                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_ManageCustomerList>
                                    <tr>


                                        <td>
                                            {{_ManageCustomerList.sno}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.chargecode}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.chargename}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.commissionpercentage}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.commissionpercentage}}
                                        </td>
                                        <td>
                                            {{_ManageCustomerList.commissionpercentage}}
                                        </td>

                                    </tr>
                                </ng-template>
                            </p-table>
                        </div> -->
                        <!--div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Temp Customer Site Validation</h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td style="width:17%" class="text-right">
                                    GST Status<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_GSTStatus" optionValue="statusid"  optionLabel="statusname"></p-dropdown>
                                </td>
                                <td style="width:17%" class="text-right">
                                    Validation Based on<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <p-dropdown [autoDisplayFirst]="false" placeholder="Select" [filter]="true" [options]="_Basedon" optionValue="basedid"  optionLabel="basedname"></p-dropdown>
                                </td>
                                <td style="width:17%" class="text-right">

                                    Document ID Number<span class="hlt-txt">*</span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <input type="text"  pInputText>
                                        <button pButton label="Verify" class="p-button-success"></button>
                                    </div>
                                </td>

                            </tr>
                           
                        </table-->
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments History </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <p-table #dt [value]="_ApprovalComment" [rows]="10" [paginator]="true"
                            [rowsPerPageOptions]="[10,25,50,100]"
                            [globalFilterFields]="['flatodachargefrom','flatodachargeto']" [rowHover]="true"
                            dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [showCurrentPageReport]="true" [scrollable]="true">
                            <ng-template pTemplate="colgroup" let-columns>
                                <colgroup>
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <col style="width:150px">
                                    <!--  <col style="width:150px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px">-->
                                </colgroup>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <!-- <th style="text-align: center;width: 100px;" rowspan="2">Action</th> -->
                                    <th pSortableColumn="flatodachargefrom">Comments<p-sortIcon
                                            field="flatodachargefrom">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodachargeto">Role Name <p-sortIcon field="flatodachargeto">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodacharges">User Name<p-sortIcon field="flatodacharges">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodacharges">Date & Time<p-sortIcon field="flatodacharges">
                                        </p-sortIcon>
                                    </th>
                                    <th pSortableColumn="flatodacharges">Status<p-sortIcon field="flatodacharges">
                                        </p-sortIcon>
                                    </th>

                                    <!-- <th pSortableColumn="agentName">Effective From <p-sortIcon field="agentName">
                    </p-sortIcon>
                </th>
                <th pSortableColumn="agentName">Effective To <p-sortIcon field="agentName">
                    </p-sortIcon>
                </th> -->

                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-_KGListGrid let-i="rowIndex">
                                <tr>
                                    <!-- <td style="text-align: center">
        
        <button pButton pRipple title="Remove"
            (click)="Remove_KGListWayBill(_KGListGrid)" icon="pi pi-trash"
            class="p-button-danger p-mr-2"></button>
    </td> -->
                                    <td>
                                        {{_KGListGrid.approvalComments}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.approverRoleName}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.approverUserName}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.createdon | date:'dd/MM/yyyy HH:ss'}}
                                    </td>
                                    <td>
                                        {{_KGListGrid.approversStatus}}
                                    </td>

                                    <!-- <td>
                    {{_agentListGrid.agentName}}
                </td>
                <td>
                    {{_agentListGrid.agentName}}
                </td> -->

                                </tr>
                            </ng-template>
                        </p-table>
                        <div class="sub-title">
                            <div class="row">
                                <div class="col-md-5">
                                    <h5>Comments </h5>
                                </div>
                                <div class="col-md-7"></div>
                            </div>
                        </div>
                        <table class="normal-table">

                            <tr>

                                <td class="text-right">Comments<span class="hlt-txt">*</span></td>
                                <!-- <td> -->
                                <td colspan="5">
                                    <form [formGroup]="_ConversionForm"><textarea inputId="textarea"
                                            formControlName="comments" rows="2" cols="30" pInputTextarea></textarea>
                                    </form>
                                    <span class="text-danger"
                                        *ngIf="(_submitted || _ConversionForm.get('comments').touched) && _ConversionForm.get('comments').errors?.ConversionRequired">
                                        Please enter Comments
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Save" class="p-button-success" (click)="onSaveConversion()"
                                        icon="las la-check"></button>
                                    <button pButton label="Clear" class="p-button-warning" (click)="clearconversion()"
                                        icon="las la-broom"></button>
                                </td>
                            </tr>
                        </table>
                        <p-dialog header="CustomerList" [(visible)]="displayBasic" [modal]="true"
                            [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
                            <ng-template pTemplate="content">
                                <div class="popup-body">
                                    <div class="search-container">
                                        <div class="p-inputgroup">
                                            <span class="p-float-label">
                                                <input type="text" id="inputtext" pInputText>
                                            </span>
                                            <button class="p-inputgroup-addon p-button" title="Search">
                                                <i class="pi pi-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <p-table [value]="CustomerList" selectionMode="single"
                                            [(selection)]="selectedRequest" (onRowSelect)="onRowSelectPopup($event)"
                                            (onRowUnselect)="onRowUnSelectPopup($event)" [paginator]="true" [rows]="10">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <!-- <th *ngIf="_action != 'view'">
                                                </th> -->
                                                    <th pSortableColumn="customername">Customer Name <p-sortIcon
                                                            field="customername">
                                                        </p-sortIcon>
                                                    </th>
                                                    <!-- <th pSortableColumn="requestedbranch">Customer Tally ID
                                                        <p-sortIcon field="requestedbranch">
                                                        </p-sortIcon>
                                                    </th> -->
                                                    <th pSortableColumn="customersitename">Customer Type <p-sortIcon
                                                            field="customersitename">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="istransporter">Is Transporter
                                                        <p-sortIcon field="istransporter">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="billingcycle">Billing Cycle
                                                        <p-sortIcon field="billingcycle">
                                                        </p-sortIcon>
                                                    </th>
                                                    <th pSortableColumn="pan">Pan No
                                                        <p-sortIcon field="pan">
                                                        </p-sortIcon>
                                                    </th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-rowData let-_CustomerPreList>
                                                <tr [pSelectableRow]="rowData">
                                                    <!-- <td style="text-align: center" *ngIf="_action != 'view'">
                                                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                                </td> -->
                                                    <td>{{_CustomerPreList.customername}}</td>
                                                    <td>{{_CustomerPreList.customersitename}}</td>
                                                    <!-- <td>{{_Expense.balanceamount}}</td> -->
                                                    <td>{{_CustomerPreList.istransporter}}</td>
                                                    <td>{{_CustomerPreList.billingcycle}}</td>
                                                    <td>{{_CustomerPreList.pan}}</td>

                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </ng-template>
                        </p-dialog>
                        <p-dialog #warning [style]="{width: '400px'}" header="Success"
                            [(visible)]="displaySuccessMSG" [modal]="true" [baseZIndex]="10000"
                            [draggable]="false" [resizable]="false" [closable]="false">
                            <ng-template pTemplate="content">
                                <label>{{_SuccessMessage}}</label>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <button type="button" pButton icon="las la-check" label="Ok" autofocus
                                    (click)="Ok()"></button>                            
                            </ng-template>
                        </p-dialog>
                        <div class="page-loader" *ngIf="_IsProgressSpinner">
                            <p-progressSpinner strokeWidth="5"></p-progressSpinner>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>